export const tryJsonParse = (jsonString) => {
  try {
    var o = JSON.parse(jsonString)
    if (o && typeof o === 'object') {
      return o
    }
  } catch (e) {
  }

  return false
}

export const removeHtmlTag = (value) => {
  return value.replace(/<[^>]*>?/gm, '')
}

export const getCellCoord = (element, refElement) => {
  return {
    col: element.cellIndex - 1,
    lig: (element.parentNode.rowIndex - 2),
    elementLigne: refElement
  }
}

export const convertToLetterOne = (num) => {
  let baseChar = ('A').charCodeAt(0)
  let letters = ''
  let theChar = []
  let number = 0

  for (let i = 1; i <= num; i++) {
    number = i

    while (number > 0) {
      number -= 1
      letters = String.fromCharCode(baseChar + (number % 26)) + letters
      number = (number / 26) >> 0
    }
    theChar = letters
    letters = ''
  }

  return theChar
}
export const formatNumber = (n, dp = 2) => {
  let e = ''
  let s = e + n
  let l = s.length
  let b = n < 0 ? 1 : 0
  let i = s.lastIndexOf('.')
  if (i === -1) {
    dp = 0
  }
  let j = i === -1 ? l : i
  let r = e
  let d = s.substr(j + 1, dp)
  while ((j -= 3) > b) {
    r = ' ' + s.substr(j, 3) + r
  }
  return (
    s.substr(0, j + 3) +
    r +
    (dp
      ? '.' + d + (d.length < dp ? '00000'.substr(0, dp - d.length) : e)
      : e)
  )
}



// WEBPACK FOOTER //
// ./src/utils/util.js